import { FormInstance, FormListFieldData } from "@/shared/form/form";
import { FormListProps } from "antd/es/form";

export function getFieldNameByAttributeCode({
  attributeCode,
  fields,
  form,
  listName,
}: {
  attributeCode: string;
  fields: FormListFieldData[];
  form: FormInstance;
  listName: FormListProps["name"];
}) {
  const field = fields.find(
    (field) =>
      form.getFieldValue([listName, field.name, "attributeCode"]) ===
      attributeCode,
  );
  return field ? field.name : null;
}
